import request from "../request";
// 获取助推列表
export function getaddBoostList(data) {
  return request({
    url: "/ld/ksPopulationBundle/getListData",
    method: "post",
    data,
  });
}
// 批量复制
export function BatchBuy(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderStarVideoCreate",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}
export function getManualListData(data) {
  return request({
    url: "/ld/ksAdvertiserDetails/getManualListData",
    method: "post",
    data,
  });
}
export default {
    getaddBoostList,
    BatchBuy,
    getManualListData
};
